module.exports = __webpack_public_path__ + "static/media/cross.d1b570e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/actions/cross.svg
// module id = 550
// module chunks = 0